import React from 'react';
import { pedidoEsPami } from '../utils/tratamientoAprobacion';

export default function PamiBadge({ pedido, compact = false }) {
  const show = pedidoEsPami(pedido);
  if (!show) return null;
  return (
    <span
      title="Cobertura PAMI detectada en este pedido"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? 6 : 8,
        padding: compact ? '3px 8px' : '5px 10px',
        borderRadius: 999,
        background: 'linear-gradient(135deg,#fde68a,#f59e0b)',
        color: '#92400e',
        fontSize: compact ? 10 : 11,
        fontWeight: 800,
        letterSpacing: '.03em',
        lineHeight: 1,
        border: '1px solid rgba(245,158,11,.16)',
        whiteSpace: 'nowrap',
        flexShrink: 0
      }}
    >
      <strong style={{ fontSize: compact ? 10 : 11 }}>PAMI</strong>
    </span>
  );
}
